import { render, staticRenderFns } from "./DeliveryServicesModal.vue?vue&type=template&id=1d48bc60&lang=pug&"
import script from "./DeliveryServicesModal.vue?vue&type=script&lang=ts&"
export * from "./DeliveryServicesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports